import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const captureTransaction = ({
  transactionId,
  amount
}: {
  transactionId: number,
  amount: number
}) => {

  const params = {
    transaction_id: transactionId,
    amount_cents: amount,
  };

  return axiosPrivate.post(`/dashboard/api/v1/capture`, params);
};